import type { RouteRecordRaw } from 'vue-router';
import { buildModuleRoutes as buildCoreModuleRoutes } from '@/app-router/build-module-routes';
import {
  mergeAppRoutes as mergeCoreAppRoutes,
  partitionRoutesForSync,
  isCatchAllRoute,
  isProtectedRoute as isCoreProtectedRoute,
} from '@/app-router/merge-app-routes';
import {
  createAppRoutes as createConfiguredAppRoutes,
  getFixedRoutesExcludingModules as getCoreFixedRoutesExcludingModules,
  reconcileRouterWithBrowserUrl,
  syncModuleRoutes as syncConfiguredModuleRoutes,
} from '@/app-router/sync-module-routes';
import { getModulePageComponent, getModulePageComponentKeys } from '@/app-router/citizen/components-map';
import { MERGE_APP_ROUTES_CONTEXT, MODULE_REGISTRY } from '@/app-router/citizen/module-registry';

const ROUTING_CONTEXT = { settingsKeyPrefix: 'citizen_module' };

const APP_ROUTER_OPTIONS = {
  registry: MODULE_REGISTRY,
  getComponent: getModulePageComponent,
  mergeContext: MERGE_APP_ROUTES_CONTEXT,
  routingContext: ROUTING_CONTEXT,
};

export { reconcileRouterWithBrowserUrl, partitionRoutesForSync, isCatchAllRoute, getModulePageComponentKeys };
export * from '@/app-router/citizen/module-registry';

export function buildModuleRoutes(settings: Record<string, unknown> = {}) {
  return buildCoreModuleRoutes(settings, MODULE_REGISTRY, getModulePageComponent, ROUTING_CONTEXT);
}

export function isProtectedRoute(route: RouteRecordRaw | undefined) {
  return isCoreProtectedRoute(route, MERGE_APP_ROUTES_CONTEXT);
}

export function mergeAppRoutes(moduleRoutes: RouteRecordRaw[], fixedRoutes: RouteRecordRaw[]) {
  return mergeCoreAppRoutes(moduleRoutes, fixedRoutes, MERGE_APP_ROUTES_CONTEXT);
}

export function createAppRoutes(fixedRoutes: RouteRecordRaw[], settings: Record<string, unknown> = {}) {
  return createConfiguredAppRoutes(fixedRoutes, settings, APP_ROUTER_OPTIONS);
}

export async function syncModuleRoutes(
  router: import('vue-router').Router,
  fixedRoutes: RouteRecordRaw[],
  settings: Record<string, unknown> = {},
) {
  return syncConfiguredModuleRoutes(router, settings, {
    ...APP_ROUTER_OPTIONS,
    fixedRoutes,
  });
}

export function getFixedRoutesExcludingModules(fixedRoutes: RouteRecordRaw[]) {
  return getCoreFixedRoutesExcludingModules(fixedRoutes, MERGE_APP_ROUTES_CONTEXT);
}

export { default as citizenFixedRoutes } from '@/app-router/citizen/fixed-routes.generated.js';
export { useModuleRoutes, moduleRoutesReadyPromise } from '@/app-router/citizen/use-module-routes';
